import React from "react";
import Hidden from "@material-ui/core/Hidden";
import TableCell from "@material-ui/core/TableCell";
import Radio from "@material-ui/core/Radio";
import { SurveyFormContext } from "../Survey";

interface RadioInputProps {
  questionId: number;
  checkedValue: number | null;
  min_value: number;
  max_value: number;
  step: number;
}
const RadioInput: React.FC<RadioInputProps> = (props: RadioInputProps) => {
  const { questionId, checkedValue, min_value, max_value, step } = props;
  let values: Array<number> = [];
  for (let i = min_value; i < max_value + step; i += step) {
    values.push(i);
  }

  const { setAnswerValue } = React.useContext(SurveyFormContext);

  return (
    <React.Fragment>
      {values.map((value) => (
        <TableCell key={value} align="center">
          <Hidden smDown>
            <Radio
              value={value}
              checked={value === checkedValue}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setAnswerValue(questionId, Number(event.target.value));
              }}
            />
          </Hidden>
          <Hidden mdUp>
            <Radio
              size="small"
              value={value}
              checked={value === checkedValue}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setAnswerValue(questionId, Number(event.target.value));
              }}
            />
          </Hidden>
        </TableCell>
      ))}
    </React.Fragment>
  );
};

export default RadioInput;
